import { PrivacyPolicyWrap } from './style';
import { Link } from "react-router-dom";

export function PrivacyPolicy() {
  return(
      <PrivacyPolicyWrap>
          <h3 className="mt-0">AVISO DE PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS DO GRUPO DEXCO</h3>
          <p>
              Os sites da Dexco conectam você (Titular), às diversas soluções em suas linhas de negócio tais como
              Duratex
              Madeira, Durafloor, Ceusa, Portinari, DEXperience, Hydra, Castelatto e Deca.
          </p>
          <p>
              Esse aviso descreve as formas de utilização de seus dados pessoais e os seus direitos como Titular, bem
              como
              todos os assuntos descritos abaixo.
          </p>

          <h3>Dados Tratados no Grupo Dexco </h3>

          <p>Ao interagir conosco alguns de seus dados pessoais podem ser coletados ou fornecidos por você. Nosso
              compromisso é trazer transparência e demonstrar o uso ético dos seus dados pessoais.</p>
          <p>A Dexco pode compartilhar seus dados pessoais com parceiros comerciais para prestação dos serviços ou
              execução de atividades comerciais, mas também com autoridades e demais interessados, para cumprimento de
              obrigações legais, proteção de seus interesses, ou mediante ordem judicial, pelo requerimento de
              autoridades
              administrativas. Todos os parceiros da Dexco passam por uma análise para assegurar medidas de proteção
              adequadas para o tratamento de seus dados. </p>
          <p>Abaixo esclarecemos como e quais dados são utilizados internamente, com relação a este site:</p>

          <div className="box">
              <h4>Clube Instaladores</h4>
              <p><a href="https://www.clubeinstaladores.com.br/"> https://www.clubeinstaladores.com.br/</a></p>

              <h4>Quais dados pessoais são utilizados?</h4>
              <p>
                  Nome completo, CPF, data de nascimento, profissão, e-mail, celular, endereço completo e sexo.
              </p>

              <h4>Para que utilizamos seus dados pessoais?</h4>
              <p>
                  Para cadastro de instaladores hidráulicos, maridos de aluguel, mestres de obras, entre outras pessoas
                  interessadas, em conteúdo sobre hidráulica no programa de relacionamento Clube Instaladores para fins
                  de
                  participação; para recebimento de comunicações relacionadas [como novidades e informações sobre o
                  programa,
                  site, cadastro de notas fiscais, cursos, prêmios, benefícios e eventos] e comunicações sobre as marcas
                  e
                  produtos do grupo Dexco via E-mail ou SMS
              </p>

              <h4>Com quem compartilhamos seus dados pessoais?</h4>

              <p>
                  Compartilhamos os seus dados pessoais com os seguintes terceiros, ou similares contratados por ela,
                  para as
                  finalidades descritas abaixo:<br></br>

                  - MarketData: tratamento da base de dados cadastros;<br></br>

                  - Amazon Web Services [EUA]: Infraestrutura tecnológica e armazenamento de dados [serviços de nuvem |
                  cloud];<br></br>

                  - Secap: atendimento às determinações de autoridades competentes; e<br></br>

                  - Securiti.ai: Ferramenta para gestão e operacionalização do Programa de Privacidade Dexco <br></br>
              </p>

              <h4>Fundamento legal:</h4>
              <p>Consentimento [exceto quanto ao atendimento à SECAP, que nos baseamos no fundamento de cumprimento de
                  obrigação legal].</p>
          </div>

          <h3>Conservação e Eliminação de dados</h3>
          <p>
              Manteremos seus dados pessoais armazenados enquanto for necessário, para prestar serviços, para fins
              legítimos, considerando o prazo de até 10 anos, e para cumprimento de obrigações legais. Conservamos
              alguns dos seus dados pessoais enquanto seu cadastro permanecer ativo nos portais do Grupo Dexco.
          </p>
          <p>
              Quando solicitado, eliminaremos os seus dados pessoais, exceto se for legalmente permitido, incluindo
              situações como as seguintes:
          </p>
          <ul>
              <li>
                  Se formos obrigados a manter os dados pessoais para as nossas obrigações legais, jurídicas, fiscais,
                  de
                  auditoria e contabilidade, mantendo apenas pelo período exigido pela legislação aplicável; ou
              </li>
              <li>
                  Sempre que necessário para a prevenção de fraudes ou para manter a segurança do nosso ambiente e
                  demais
                  usuários do portal/site.
              </li>
          </ul>

          <h3>Gestão de Cookies</h3>
          <p>
              Cookies são arquivos ou informações que podem ser armazenadas em seus dispositivos, quando você visita o
              site.
              A Dexco utiliza cookies para facilitar o uso e melhor adaptar seus sites e aplicativos aos interesses e
              necessidades de cada usuário, sendo dividido em quatro categorias:
          </p>
          <ul>
              <li>
                  <b>Necessários:</b> Esses cookies são essenciais para que os sites e aplicativos carreguem
                  corretamente e permitam
                  que você navegue e faça uso de todas as funcionalidades disponíveis.
              </li>
              <li>
                  <b>Desempenho:</b> Esses cookies nos ajudam a entender como os visitantes interagem com sites e
                  aplicativos,
                  fornecendo informações sobre as áreas visitadas, o tempo de visita e quaisquer problemas encontrados,
                  como
                  mensagens de erro.
              </li>
              <li>
                  <b>Funcionais:</b> Esses cookies permitem que sites e aplicativos se lembrem das escolhas dos
                  usuários, para
                  proporcionar uma experiência mais personalizada. Também, possibilitam que os usuários utilizem a
                  integração
                  com redes sociais, campos para comentários, entre outros.
              </li>
              <li>
                  <b>Marketing:</b> Esses cookies são utilizados para fornecer mais conteúdo relevante e do interesse
                  dos usuários.
                  Podem ser utilizados para apresentar publicidade direcionada ou limitar sua veiculação.
              </li>
          </ul>

          <p>Ao logar pela primeira vez em nossos sites ou aplicativos, você poderá gerenciar os cookies, por meio do
              banner de preferências.</p>

          <p>A qualquer momento, você poderá rever a forma de aplicação dos cookies, através das configurações de seu
              navegador de preferência.</p>

          <p>Caso você não permita a utilização de alguns cookies, certos serviços poderão não funcionar de maneira
              adequada.</p>

          <h3>Segurança da Informação e dos Dados Pessoais</h3>

          <p>
              A Dexco adota medidas de segurança para manter a confidencialidade, a integridade, a disponibilidade e
              autenticidade das informações e dos dados pessoais em seus sites e aplicativos, incluindo as diretrizes
              sobre
              padrões de segurança estabelecidas nas legislações e regulamentações aplicáveis, tais como métodos de
              criptografia de dados, proteção contra acessos não autorizados, entre outros.
          </p>

          <p>
              A Dexco coleta e armazena pelo período necessário os dados de acesso aos seus sites e aplicativos (data,
              hora
              e IP), para cumprimento de obrigação legal imposta pelo Marco Civil da Internet (art. 15, Lei nº
              12.965/2014).
          </p>

          <p>
              Apesar de todas as medidas de segurança que adotamos, é importante lembrar que nenhum site ou aplicativo é
              completamente imune a riscos. Por isso, recomendamos fortemente que você também adote práticas de
              segurança
              para proteger seus dados pessoais. Algumas dessas práticas incluem manter seus logins e senhas em sigilo,
              utilizar senhas fortes e únicas para cada serviço, ativar a autenticação em duas etapas sempre que
              possível, e
              estar atento a possíveis tentativas de phishing ou outras formas de fraude online.
          </p>

          <h3>Seus Direitos</h3>

          <p>
              As leis brasileiras de privacidade e proteção de dados pessoais asseguram a você, titular de dados
              pessoais,
              uma série de garantias que o colocam no controle das informações que você nos fornece. Como modo de
              informá-lo
              sobre os seus Direitos e como exercê-los, apresentamos a seguir tudo aquilo que se aplica a você.
          </p>

          <p>
              Para exercer esses direitos, você pode solicitá-los à Dexco, por meio do <a
              href="https://privacy-central.securiti.ai/#/dsr/e2cf4abb-3064-4a33-a9d6-b93caafcda6e"> Portal de Abertura
              de
              Solicitações de Titulares (DSR).</a>
          </p>

          <p>Importante ressaltar que representantes legais poderão exercer os direitos em nome do titular, desde que
              comprovados os poderes para essa atividade.</p>

          <p>Conforme previsto na LGPD, você pode exercer os seguintes direitos com relação aos seus dados pessoais:</p>


          <ul>
              <li>
                  <b>Confirmar a existência de tratamento:</b> este direito permite que o titular de dados requisite e
                  receba uma
                  confirmação sobre a existência de coleta, armazenamento, compartilhamento ou qualquer tipo de
                  tratamento a
                  partir de seus dados;
              </li>
              <li>
                  <b>Dar acesso aos dados:</b> este direito permite que o titular de dados requisite e receba uma cópia
                  gratuita e em
                  formato acessível dos dados tratados;
              </li>
              <li>
                  <b>Corrigir dados incompletos, inexatos ou desatualizados:</b> este direito permite que o titular de
                  dados
                  requisite a retificação de seus dados;
              </li>
              <li>
                  <b>Anonimizar, bloquear ou eliminar dados desnecessários, excessivos ou tratados em desconformidade
                      com a LGPD:</b>
                  este direito permite que o titular de dados requisite a anonimização, o bloqueio ou a eliminação dos
                  dados
                  da base da Dexco. Os dados tratados serão anonimizados, bloqueados ou eliminados dos servidores e
                  arquivos
                  físicos da Dexco, quando assim for possível e requisitado pelo titular e, em conformidade com o
                  atendimento
                  a outras legislações vigentes aplicáveis;
              </li>
              <li>
                  <b>Enviar dados a outro fornecedor de serviços e/ou produto, mediante requisição expressa, observados
                      os
                      segredos comercial e industrial:</b> este direito permite que o titular de dados requisite a
                  transferência dos
                  dados tratados à outra parte, em formato estruturado e interoperável;
              </li>
              <li><b>Revogar o consentimento e/ou eliminar dados tratados com consentimento do titular:</b> estes
                  direitos permitem
                  que o titular de dados requisite a revogação do consentimento dado anteriormente e/ou eliminação dos
                  dados
                  tratados. Ainda, é seu direito não fornecê-lo à Dexco, que deve informá-lo sobre as consequências da
                  negativa;
              </li>

              <li><b>Obter informações sobre o compartilhamento de seus dados:</b> este direito permite que o titular de
                  dados
                  requisite com quais entidades públicas e privadas seus dados são compartilhados;
              </li>

              <li><b>Peticionar contra o Controlador:</b> este direito permite que o titular de dados requisite auxílio
                  à ANPD,
                  caso não consiga exercer seus direitos perante o Controlador;
              </li>

              <li><b>Revisar e fornecer informações sobre as decisões tomadas unicamente com base em tratamento
                  automatizado de
                  dados que afetem seus interesses, incluídas as decisões destinadas a definir o seu perfil pessoal,
                  profissional, de consumo e de crédito ou os aspectos de sua personalidade:</b> este direito permite
                  que o
                  titular de dados requisite a revisão de decisões tomadas unicamente com base em tratamento
                  automatizado dos
                  dados e receba informações claras e adequadas a respeito dos critérios utilizados nas decisões, desde
                  que
                  estas não violem qualquer segredo comercial da Companhia; e
              </li>

              <li><b>Não realizar tratamento com fundamento em uma das hipóteses de dispensa de consentimento:</b> este
                  direito
                  permite que o titular de dados se oponha a usos de seus dados pessoais que dispensam consentimento.
              </li>
          </ul>

          <p>
              Ainda, te informamos que nosso time retornará a você com uma resposta dentro do prazo legal, a partir do
              recebimento da requisição. Se verificada a necessidade de esclarecimentos complementares, os prazos legais
              de
              atendimento estarão suspensos até o recebimento da sua resposta.
          </p>

          <h3>Encarregado pelo Tratamento de Dados Pessoais</h3>

          <p>
              A Dexco tem em sua estrutura um Encarregado pelo Tratamento de Dados Pessoais, Gustavo Conte Jakovac,
              precisamente para garantir que tenhamos sempre as melhores diretrizes e orientações sobre o tratamento de
              dados pessoais.
          </p>

          <p>Ele é o canal de comunicação sobre os temas de privacidade e proteção de dados com as autoridades
              competentes e com você. Por isso, caso tenha alguma dúvida, sugestão ou solicitação, entre em contato no
              e-mail <a href="mailto:dpo@dex.co">dpo@dex.co</a>.
          </p>


          <h3>Atualizações Desta Política</h3>

          <p>A Dexco manterá esse Aviso sempre atualizado, para que ele reflita a realidade sobre o tratamento de seus
              dados pessoais em nossos sites e aplicativos.
          </p>

          <h3>DEXCO</h3>
          <p>
              Endereço: Av. Paulista - 1938 - Bela Vista <br/>
              São Paulo – SP CEP: 01310-942 <br/>
              Telefone: (11) 3179-7733 <br/>
              CNPJ: 97.837.181/0001-47 <br/>
              Inscrição Estadual: 114.578.650.114
          </p>

          <p className="text-right">Última atualização em 09/12/2024.</p>

          <p>
              <Link to="/old-privacity" target="_blank" rel="noopener noreferrer">
                  Versões Anteriores
              </Link>
          </p>
      </PrivacyPolicyWrap>
  )
}